export default async (authService) => {
    let idClaims = await authService.getIdTokenClaims();
    const { exp } = idClaims;

    const nowSeconds = Math.floor(Date.now() / 1000);

    // if id token has expired or is about to expire, refresh
    if (nowSeconds + 60 > exp) {
        await authService.getTokenSilently({
            cacheMode: 'off',
        });

        idClaims = await authService.getIdTokenClaims();
    }

    const { __raw: rawToken } = idClaims;
    return rawToken;
};
